(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("lodash"), require("validator"));
	else if(typeof define === 'function' && define.amd)
		define("Superform", ["react", "lodash", "validator"], factory);
	else if(typeof exports === 'object')
		exports["Superform"] = factory(require("react"), require("lodash"), require("validator"));
	else
		root["Superform"] = factory(root["React"], root["_"], root["validator"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_4__) {
return 


/** WEBPACK FOOTER **
 ** webpack/universalModuleDefinition
 **/